/**
 * product-preparation.js
 *
 * Integra:
 * - Modal de fecha de entrega
 * - Calendario UI custom (lp-cal)
 * - Horarios por día (ShopServiceSchedule.weekly + slotMinutes)
 * - Fechas en formato largo: "23 de Noviembre del 2026"
 */

/* ---------------------------
   UTILIDADES DE HORARIOS
---------------------------- */

function timeToMinutes(hhmm) {
  var p = String(hhmm || "").split(":");
  if (p.length !== 2) return null;
  var h = parseInt(p[0], 10);
  var m = parseInt(p[1], 10);
  if (isNaN(h) || isNaN(m)) return null;
  return h * 60 + m;
}

function minutesToTime(min) {
  var h = Math.floor(min / 60);
  var m = min % 60;
  return String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0");
}

/* ---------------------------
   FORMATO FECHA LARGO ES
---------------------------- */

function formatDisplayDateLongES(ymd) {
  var parts = String(ymd || "").split("-");
  if (parts.length !== 3) return String(ymd || "");

  var y = parseInt(parts[0], 10);
  var m = parseInt(parts[1], 10);
  var d = parseInt(parts[2], 10);

  var months = [
    "Enero","Febrero","Marzo","Abril","Mayo","Junio",
    "Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"
  ];

  if (!y || !m || !d || !months[m - 1]) return String(ymd || "");
  return d + " de " + months[m - 1] + " del " + y;
}

function parseYMDToLocalDate(ymd) {
  var p = String(ymd || "").split("-");
  if (p.length !== 3) return null;
  return new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));
}

function isNextDayLocal(a, b) {
  var x = new Date(a.getFullYear(), a.getMonth(), a.getDate());
  var y = new Date(b.getFullYear(), b.getMonth(), b.getDate());
  x.setDate(x.getDate() + 1);
  return x.getTime() === y.getTime();
}

function toContinuousDateRanges(ymdList) {
  var list = (ymdList || []).slice().sort(); // YYYY-MM-DD se ordena bien

  var ranges = [];
  var start = null;
  var prev = null;

  for (var i = 0; i < list.length; i++) {
    var cur = parseYMDToLocalDate(list[i]);
    if (!cur) continue;

    if (!start) {
      start = cur;
      prev = cur;
      continue;
    }

    if (isNextDayLocal(prev, cur)) {
      prev = cur;
      continue;
    }

    ranges.push({ start: start, end: prev });
    start = cur;
    prev = cur;
  }

  if (start) ranges.push({ start: start, end: prev });
  return ranges;
}

function formatDateRangeES(range) {
  function toYMD(d) {
    return (
      d.getFullYear() +
      "-" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(d.getDate()).padStart(2, "0")
    );
  }

  var sameDay = range.start.getTime() === range.end.getTime();
  if (sameDay) return formatDisplayDateLongES(toYMD(range.start));
  return (
    formatDisplayDateLongES(toYMD(range.start)) +
    " al " +
    formatDisplayDateLongES(toYMD(range.end))
  );
}

function formatBlockedDatesMessageES(blockedInRange) {
  var ranges = toContinuousDateRanges(blockedInRange);
  if (!ranges.length) return "";

  var parts = ranges.map(formatDateRangeES);
  return "No hay servicio en: <strong>" + parts.join(", ") + "</strong>.";
}

/* ---------------------------
   MODAL (ABRIR / CERRAR)
---------------------------- */

function wireDeliveryModal() {
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;

  var addBtn = form.querySelector("[data-add-to-cart]");
  if (!addBtn) return;

  if (form.dataset.deliveryModalWired === "1") return;
  form.dataset.deliveryModalWired = "1";

  var modal = document.getElementById("delivery-modal");
  var overlay = document.getElementById("delivery-modal-overlay");
  var cancelBtn = document.getElementById("delivery-cancel");
  var confirmBtn = document.getElementById("delivery-confirm");
  var dateInput = document.getElementById("delivery-date");
  var timeSelect = document.getElementById("delivery-time");

  if (!modal || !overlay || !cancelBtn || !confirmBtn || !dateInput) return;
  if (!timeSelect) return;

  modal.hidden = true;
  overlay.hidden = true;

  var modalConfirmed = false;

  function openModal() {
    modal.hidden = false;
    overlay.hidden = false;

    if (typeof wireDeliveryDatePicker === "function") wireDeliveryDatePicker();
    if (typeof wireDeliveryCalendarUI === "function") wireDeliveryCalendarUI();
  }

  function closeModal() {
    modal.hidden = true;
    overlay.hidden = true;
  }

  function ensureDeliveryPropertyInForm(value) {
    var propName = "properties[Fecha de entrega]";
    var propInput = form.querySelector('input[name="' + propName + '"]');

    if (!propInput) {
      propInput = document.createElement("input");
      propInput.type = "hidden";
      propInput.name = propName;
      form.appendChild(propInput);
    }

    propInput.value = value;
  }

  function ensureDeliveryTimePropertyInForm(value) {
    var propName = "properties[Horario de entrega]";
    var propInput = form.querySelector('input[name="' + propName + '"]');

    if (!propInput) {
      propInput = document.createElement("input");
      propInput.type = "hidden";
      propInput.name = propName;
      form.appendChild(propInput);
    }

    propInput.value = value;
  }

  function getCurrentVariantId() {
    var variantEl = form.querySelector('[name="id"]');
    if (!variantEl) return null;
    var v = parseInt(variantEl.value, 10);
    return isNaN(v) ? null : v;
  }

  function removeVariantFromCartIfExists(variantId) {
    if (!variantId) return Promise.resolve();

    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart && cart.items ? cart.items : [];
        var matches = items.filter(function (it) { return it.variant_id === variantId; });
        if (!matches.length) return;

        var chain = Promise.resolve();
        matches.forEach(function (it) {
          chain = chain.then(function () {
            return fetch("/cart/change.js", {
              method: "POST",
              credentials: "same-origin",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: it.key, quantity: 0 })
            });
          });
        });

        return chain;
      })
      .catch(function (err) {
        console.warn("[DeliveryModal] No se pudo limpiar variante previa:", err);
      });
  }

  function submitThroughTheme() {
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit(addBtn);
    } else {
      form.submit();
    }
  }

  addBtn.addEventListener(
    "click",
    function (e) {
      if (modalConfirmed) return;
      e.preventDefault();
      e.stopPropagation();
      openModal();
    },
    true
  );

  form.addEventListener("submit", function (e) {
    if (modalConfirmed) return;
    e.preventDefault();
    openModal();
  });

  cancelBtn.addEventListener("click", function (e) {
    e.preventDefault();
    closeModal();
  });

  overlay.addEventListener("click", closeModal);

  confirmBtn.addEventListener("click", function (e) {
    e.preventDefault();

    if (!dateInput.value) {
      alert("Por favor selecciona una fecha de entrega válida.");
      return;
    }
    if (!timeSelect.value) {
      alert("Por favor selecciona un horario de entrega válido.");
      return;
    }

    ensureDeliveryPropertyInForm(dateInput.value);
    ensureDeliveryTimePropertyInForm(timeSelect.value);

    var variantId = getCurrentVariantId();

    modalConfirmed = true;
    closeModal();

    removeVariantFromCartIfExists(variantId).then(function () {
      submitThroughTheme();
      setTimeout(function () { modalConfirmed = false; }, 1500);
    });
  });
}

/* ---------------------------
   REGLAS SERVICIO (DÍAS)
---------------------------- */

function getWeekdayKey(date) {
  var day = date.getDay();
  var map = ["sunday","monday","tuesday","wednesday","thursday","friday","saturday"];
  return map[day];
}

function isClosedDate(date) {
  var cfg = window.ShopServiceSchedule;
  if (!cfg || !Array.isArray(cfg.closedDates)) return false;

  var y = date.getFullYear();
  var m = String(date.getMonth() + 1).padStart(2, "0");
  var d = String(date.getDate()).padStart(2, "0");
  var key = y + "-" + m + "-" + d;

  return cfg.closedDates.indexOf(key) !== -1;
}

function getServiceWindowForDate(date) {
  var cfg = window.ShopServiceSchedule;
  if (!cfg || !cfg.weekly) return { closed: true };

  var weekdayKey = getWeekdayKey(date);
  var dayCfg = cfg.weekly[weekdayKey];

  if (!dayCfg || dayCfg.closed) return { closed: true };

  return { closed: false, open: dayCfg.open, close: dayCfg.close };
}

function isServiceClosedOn(date) {
  var win = getServiceWindowForDate(date);
  if (!win || win.closed) return true;
  if (isClosedDate(date)) return true;
  return false;
}

function findNextOpenDate(startDate, minDateStr, maxDateStr) {
  var date = new Date(startDate.getTime());
  var minDate = null;
  var maxDate = null;

  function parseYMD(str) {
    var p = String(str || "").split("-");
    if (p.length !== 3) return null;
    return new Date(parseInt(p[0],10), parseInt(p[1],10)-1, parseInt(p[2],10));
  }

  if (minDateStr) minDate = parseYMD(minDateStr);
  if (maxDateStr) maxDate = parseYMD(maxDateStr);

  if (minDate && date < minDate) date = new Date(minDate.getTime());

  for (var i = 0; i < 365; i++) {
    if (maxDate && date > maxDate) return null;
    if (!isServiceClosedOn(date)) return date;
    date.setDate(date.getDate() + 1);
  }
  return null;
}

/* ---------------------------
   DATE PICKER + HORARIOS
---------------------------- */

function wireDeliveryDatePicker() {
  var dateInput = document.getElementById("delivery-date");
  var helper = document.getElementById("delivery-date-helper");
  var maxEl = document.getElementById("delivery-date-max");
  var blockedEl = document.getElementById("delivery-date-blocked");

  var timeSelect = document.getElementById("delivery-time");
  var timeHelper = document.getElementById("delivery-time-helper");

  if (!dateInput) return;

  var schedule = window.ShopServiceSchedule || {};
  var closedDates = Array.isArray(schedule.closedDates) ? schedule.closedDates : [];
  var maxDaysAhead = schedule.maxDaysAhead || 0;
  var slotMinutes = schedule.slotMinutes || 60;

  // Restricción real (fecha+hora mínima)
  var minDateTime = null;

  function formatDateForInput(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, "0");
    var day = String(date.getDate()).padStart(2, "0");
    return year + "-" + month + "-" + day;
  }

  function maxDateStr(a, b) {
    return a > b ? a : b;
  }

  function minutesOfDay(d) {
    return d.getHours() * 60 + d.getMinutes();
  }

  function roundUpToStep(mins, step) {
    step = parseInt(step, 10) || 60;
    return Math.ceil(mins / step) * step;
  }

  function ymdFromDate(d) {
    return (
      d.getFullYear() +
      "-" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(d.getDate()).padStart(2, "0")
    );
  }

  function isSameYMD(ymd, d) {
    return String(ymd || "") === ymdFromDate(d);
  }

  function ensureFirstSelectableTime() {
    if (!timeSelect) return "";
    // option[0] = placeholder; option[1] = primera real
    if (!timeSelect.value && timeSelect.options && timeSelect.options.length > 1) {
      timeSelect.value = timeSelect.options[1].value;
    }
    return timeSelect.value || "";
  }

  function updateHelperMessage() {
    if (!helper) return;
    var t = ensureFirstSelectableTime();
    var timeText = t ? (" a las " + String(t).trim()) : "";
    helper.textContent =
      "La fecha más próxima disponible es: " +
      formatDisplayDateLongES(dateInput.value) +
      timeText +
      ".";
  }

  function fillTimeOptionsForSelectedDate() {
    if (!timeSelect) return;

    timeSelect.innerHTML = "";

    if (!dateInput.value) return;

    var parts = dateInput.value.split("-");
    var chosen = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));

    if (isServiceClosedOn(chosen)) {
      var opt0 = document.createElement("option");
      opt0.value = "";
      opt0.textContent = "Sin servicio este día";
      timeSelect.appendChild(opt0);
      timeSelect.value = "";
      if (timeHelper) timeHelper.textContent = "Selecciona otra fecha para ver horarios disponibles.";
      return;
    }

    var win = getServiceWindowForDate(chosen);
    var openM = timeToMinutes(win.open);
    var closeM = timeToMinutes(win.close);
    var step = slotMinutes || 60;

    if (openM === null || closeM === null) {
      var optBad = document.createElement("option");
      optBad.value = "";
      optBad.textContent = "Horario no configurado";
      timeSelect.appendChild(optBad);
      timeSelect.value = "";
      if (timeHelper) timeHelper.textContent = "No se pudo leer el horario del día.";
      return;
    }

    // Bloqueo por minDateTime (si el día seleccionado es el día mínimo)
    var startM = openM;
    if (minDateTime && isSameYMD(dateInput.value, minDateTime)) {
      startM = Math.max(openM, roundUpToStep(minutesOfDay(minDateTime), step));
    }

    if (startM > closeM) {
      var optNo = document.createElement("option");
      optNo.value = "";
      optNo.textContent = "Sin horarios disponibles";
      timeSelect.appendChild(optNo);
      timeSelect.value = "";
      if (timeHelper) timeHelper.textContent = "Ya no hay horarios disponibles para ese día. Selecciona otra fecha.";
      return;
    }

    var ph = document.createElement("option");
    ph.value = "";
    ph.textContent = "Selecciona un horario";
    timeSelect.appendChild(ph);

    for (var t = startM; t <= closeM; t += step) {
      var hhmm = minutesToTime(t);
      var o = document.createElement("option");
      o.value = hhmm;
      o.textContent = hhmm;
      timeSelect.appendChild(o);
    }

    ensureFirstSelectableTime();

    if (timeHelper) {
      timeHelper.textContent = "Horarios disponibles: " + win.open + " a " + win.close + " (cada " + step + " min).";
    }
  }

  function updateMinDateAndFixValue() {
    function dateAtMidnight(d) {
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }

    var current = window.ProductPreparation && window.ProductPreparation.currentMinPrep;
    if (!current || !current.earliestDate) {
      if (window.ProductPreparationUtils && typeof window.ProductPreparationUtils.updateCurrentMinPrep === "function") {
        window.ProductPreparationUtils.updateCurrentMinPrep(1);
        current = window.ProductPreparation.currentMinPrep;
      }
    }

    var now = new Date();
    var todayStr = formatDateForInput(now);

    // mínimo real: 24h o prepHours (mayor)
    var requiredHours = Math.max(24, Number(current && current.totalHours) || 24);
    minDateTime = new Date(now.getTime() + requiredHours * 60 * 60 * 1000);

    var baseMinDate = dateAtMidnight(minDateTime);
    var baseMinStr = formatDateForInput(baseMinDate);

    // Empuja a siguiente día si está cerrado o si ya no alcanza horarios ese día
    for (var k = 0; k < 14; k++) {
      var win = getServiceWindowForDate(baseMinDate);

      if (!win || win.closed || isClosedDate(baseMinDate)) {
        baseMinDate.setDate(baseMinDate.getDate() + 1);
        baseMinStr = formatDateForInput(baseMinDate);
        continue;
      }

      var openM = timeToMinutes(win.open);
      var closeM = timeToMinutes(win.close);
      if (openM === null || closeM === null) break;

      if (isSameYMD(baseMinStr, minDateTime)) {
        var firstSlotM = Math.max(openM, roundUpToStep(minutesOfDay(minDateTime), slotMinutes || 60));
        if (firstSlotM > closeM) {
          baseMinDate.setDate(baseMinDate.getDate() + 1);
          baseMinStr = formatDateForInput(baseMinDate);
          continue;
        }
      }

      break;
    }

    var minStr = maxDateStr(todayStr, baseMinStr);
    dateInput.min = minStr;

    var maxStr = null;
    if (maxDaysAhead && maxDaysAhead > 0) {
      var maxDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      maxDate.setDate(maxDate.getDate() + maxDaysAhead);
      maxStr = formatDateForInput(maxDate);
      dateInput.max = maxStr;
    } else {
      dateInput.removeAttribute("max");
    }

    var baseDateStr =
      dateInput.value && dateInput.value >= minStr && (!maxStr || dateInput.value <= maxStr)
        ? dateInput.value
        : minStr;

    var p = baseDateStr.split("-");
    var baseDate = new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10));

    var nextOpen = findNextOpenDate(baseDate, minStr, maxStr);
    if (!nextOpen) return;

    dateInput.value = formatDateForInput(nextOpen);

    fillTimeOptionsForSelectedDate();

    // Si este día quedó sin horarios, empuja al siguiente día abierto
    if (timeSelect && !timeSelect.value) {
      var nextDay = new Date(nextOpen.getFullYear(), nextOpen.getMonth(), nextOpen.getDate());
      nextDay.setDate(nextDay.getDate() + 1);

      var nextOpen2 = findNextOpenDate(nextDay, minStr, maxStr);
      if (nextOpen2) {
        dateInput.value = formatDateForInput(nextOpen2);
        fillTimeOptionsForSelectedDate();
      }
    }

    updateHelperMessage();

    if (maxEl) {
      maxEl.textContent = maxStr ? ("Solo puedes programar máximo hasta el " + formatDisplayDateLongES(maxStr) + ".") : "";
    }

    if (blockedEl) {
      if (!closedDates.length) {
        blockedEl.textContent = "";
      } else {
        var blockedInRange = closedDates.filter(function (d) {
          return d >= minStr && (!maxStr || d <= maxStr);
        });

        blockedEl.innerHTML = blockedInRange.length
          ? formatBlockedDatesMessageES(blockedInRange)
          : "";
      }
    }
  }

  // Hook: cantidad cambia -> recalcula y re-ajusta
  if (window.ProductPreparationUtils && typeof window.ProductPreparationUtils.updateCurrentMinPrep === "function") {
    var originalUpdate = window.ProductPreparationUtils.updateCurrentMinPrep;
    window.ProductPreparationUtils.updateCurrentMinPrep = function (qty) {
      originalUpdate(qty);
      updateMinDateAndFixValue();
    };
  }

  dateInput.addEventListener("change", function () {
    if (!dateInput.value) return;

    if (maxDaysAhead && maxDaysAhead > 0 && dateInput.max && dateInput.value > dateInput.max) {
      dateInput.value = dateInput.max;
    }

    var parts = dateInput.value.split("-");
    var chosen = new Date(parseInt(parts[0],10), parseInt(parts[1],10)-1, parseInt(parts[2],10));

    if (isServiceClosedOn(chosen)) {
      var nextOpen = findNextOpenDate(chosen, dateInput.min, dateInput.max || null);
      if (nextOpen) {
        dateInput.value = formatDateForInput(nextOpen);
      }
    }

    fillTimeOptionsForSelectedDate();
    updateHelperMessage();
  });

  if (timeSelect) {
    timeSelect.addEventListener("change", function () {
      updateHelperMessage();
    });
  }

  updateMinDateAndFixValue();
}

/* ---------------------------
   PRODUCT PREPARATION CORE
---------------------------- */

(function () {
  if (!window.ProductPreparation) return;

  var prep = window.ProductPreparation;

  var config = {
    productId: prep.productId || null,
    handle: prep.handle || "",
    title: prep.title || "",
    minPrep: {
      days: Number(prep.minPrep && prep.minPrep.days) || 1,
      hours: Number(prep.minPrep && prep.minPrep.hours) || 0
    },
    minPrepTotalHours: typeof prep.minPrepTotalHours === "number"
      ? prep.minPrepTotalHours
      : (Number(prep.minPrep && prep.minPrep.days) || 1) * 24 + (Number(prep.minPrep && prep.minPrep.hours) || 0),
    hasMaxQuantity: !!prep.hasMaxQuantity,
    multiplier: Number(prep.multiplier) || 1,
    message: prep.message || "El mínimo preestablecido es de 1 día para no encimar pedidos.",
    shopTimezone: prep.shopTimezone || null
  };

  function calcMinPrepHoursForQuantity(quantity) {
    var qty = Number(quantity) || 1;
    var baseHours = config.minPrepTotalHours || 24;
    var multiplier = config.multiplier || 1;

    if (!config.hasMaxQuantity) return baseHours;
    if (qty > 1) return baseHours * multiplier;
    return baseHours;
  }

  function splitHoursToDaysAndHours(totalHours) {
    var hours = Number(totalHours) || 0;
    var days = Math.floor(hours / 24);
    var remainingHours = hours % 24;
    return { days: days, hours: remainingHours };
  }

  function getEarliestDateFromNow(minPrepHours) {
    var hours = Number(minPrepHours) || config.minPrepTotalHours || 24;
    var now = new Date();
    return new Date(now.getTime() + hours * 60 * 60 * 1000);
  }

  function updateCurrentMinPrep(quantity) {
    var minHours = calcMinPrepHoursForQuantity(quantity);
    var split = splitHoursToDaysAndHours(minHours);
    var earliestDate = getEarliestDateFromNow(minHours);

    window.ProductPreparation.currentMinPrep = {
      totalHours: minHours,
      days: split.days,
      hours: split.hours,
      earliestDate: earliestDate
    };
  }

  function wireQuantityListener() {
    var qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput) {
      updateCurrentMinPrep(1);
      return;
    }

    function handler() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      updateCurrentMinPrep(qty);
    }

    qtyInput.addEventListener("change", handler);
    qtyInput.addEventListener("input", handler);
    handler();
  }

  window.ProductPreparationUtils = {
    config: config,
    calcMinPrepHoursForQuantity: calcMinPrepHoursForQuantity,
    splitHoursToDaysAndHours: splitHoursToDaysAndHours,
    getEarliestDateFromNow: getEarliestDateFromNow,
    updateCurrentMinPrep: updateCurrentMinPrep
  };

  document.addEventListener("DOMContentLoaded", function () {
    wireQuantityListener();
    wireDeliveryDatePicker();
    wireDeliveryCalendarUI();
    wireDeliveryModal();
  });
})();

/* ---------------------------
   CALENDARIO UI (lp-cal)
---------------------------- */

function wireDeliveryCalendarUI() {
  var dateInput = document.getElementById("delivery-date");
  var cal = document.getElementById("lp-cal");
  if (!dateInput || !cal) return;

  var trigger = document.getElementById("lp-cal-trigger");
  var triggerLabel = document.getElementById("lp-cal-triggerLabel");
  var panel = document.getElementById("lp-cal-panel");
  var grid = document.getElementById("lp-cal-grid");
  var monthLabel = document.getElementById("lp-cal-month");
  var prevBtn = document.getElementById("lp-cal-prev");
  var nextBtn = document.getElementById("lp-cal-next");

  if (!trigger || !triggerLabel || !panel || !grid || !monthLabel || !prevBtn || !nextBtn) return;

  function pad2(n) { return String(n).padStart(2, "0"); }

  function toYMD(date) {
    return date.getFullYear() + "-" + pad2(date.getMonth() + 1) + "-" + pad2(date.getDate());
  }

  function parseYMD(str) {
    var p = String(str || "").split("-");
    if (p.length !== 3) return null;
    return new Date(parseInt(p[0],10), parseInt(p[1],10)-1, parseInt(p[2],10));
  }

  function clampToRange(date) {
    var min = dateInput.min ? parseYMD(dateInput.min) : null;
    var max = dateInput.max ? parseYMD(dateInput.max) : null;

    var d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    if (min && d < min) d = min;
    if (max && d > max) d = max;
    return d;
  }

  function isWithinRange(ymd) {
    if (dateInput.min && ymd < dateInput.min) return false;
    if (dateInput.max && ymd > dateInput.max) return false;
    return true;
  }

  var selected = parseYMD(dateInput.value) || parseYMD(dateInput.min) || new Date();
  selected = clampToRange(selected);
  var view = new Date(selected.getFullYear(), selected.getMonth(), 1);

  function setSelectedByYMD(ymd) {
    dateInput.value = ymd;
    dateInput.dispatchEvent(new Event("change", { bubbles: true }));
    triggerLabel.textContent = formatDisplayDateLongES(dateInput.value);
    selected = parseYMD(dateInput.value) || selected;
  }

  function openPanel() {
    panel.hidden = false;
    render();
  }

  function closePanel() {
    panel.hidden = true;
  }

  trigger.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (panel.hidden) openPanel();
    else closePanel();
  });

  document.addEventListener("click", function (e) {
    if (!cal.contains(e.target)) closePanel();
  });

  prevBtn.addEventListener("click", function (e) {
    e.preventDefault();
    view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
    render();
  });

  nextBtn.addEventListener("click", function (e) {
    e.preventDefault();
    view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
    render();
  });

  function monthNameES(date) {
    var months = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
    return months[date.getMonth()] + " " + date.getFullYear();
  }

  function render() {
    monthLabel.textContent = monthNameES(view);

    (function () {
      var min = dateInput.min ? parseYMD(dateInput.min) : null;
      var max = dateInput.max ? parseYMD(dateInput.max) : null;

      var prevMonthLastDay = new Date(view.getFullYear(), view.getMonth(), 0);
      var nextMonthFirstDay = new Date(view.getFullYear(), view.getMonth() + 1, 1);

      prevBtn.disabled = !!(min && prevMonthLastDay < new Date(min.getFullYear(), min.getMonth(), 1));
      nextBtn.disabled = !!(max && nextMonthFirstDay > new Date(max.getFullYear(), max.getMonth(), 1));
    })();

    grid.innerHTML = "";

    var year = view.getFullYear();
    var month = view.getMonth();

    var firstDay = new Date(year, month, 1);
    var lastDay = new Date(year, month + 1, 0);

    var jsDow = firstDay.getDay();
    var offset = (jsDow + 6) % 7;

    for (var i = 0; i < offset; i++) {
      var padBtn = document.createElement("button");
      padBtn.type = "button";
      padBtn.className = "lp-cal__day lp-cal__day--muted";
      padBtn.textContent = "";
      padBtn.disabled = true;
      grid.appendChild(padBtn);
    }

    for (var d = 1; d <= lastDay.getDate(); d++) {
      var current = new Date(year, month, d);
      var ymd = toYMD(current);

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "lp-cal__day";
      btn.textContent = String(d);

      var inRange = isWithinRange(ymd);
      var closed = isServiceClosedOn(current);

      if (!inRange || closed) {
        btn.classList.add("lp-cal__day--disabled");
        btn.disabled = true;
      }

      if (dateInput.value && ymd === dateInput.value) {
        btn.classList.add("lp-cal__day--selected");
      }

      (function (el, ymdLocal) {
        el.addEventListener("click", function (e) {
          e.preventDefault();
          if (el.disabled) return;

          setSelectedByYMD(ymdLocal);

          var final = parseYMD(dateInput.value);
          if (final) view = new Date(final.getFullYear(), final.getMonth(), 1);

          render();
          closePanel();
        });
      })(btn, ymd);

      grid.appendChild(btn);
    }

    if (dateInput.value) triggerLabel.textContent = formatDisplayDateLongES(dateInput.value);
    else if (dateInput.min) triggerLabel.textContent = formatDisplayDateLongES(dateInput.min);
    else triggerLabel.textContent = "Selecciona una fecha";
  }

  dateInput.addEventListener("change", function () {
    if (dateInput.value) triggerLabel.textContent = formatDisplayDateLongES(dateInput.value);
    render();
  });

  if (dateInput.value) triggerLabel.textContent = formatDisplayDateLongES(dateInput.value);
  else if (dateInput.min) triggerLabel.textContent = formatDisplayDateLongES(dateInput.min);
}

/* ---------------------------
   PATCH (seguro) para re-wire
---------------------------- */

(function patchWireDeliveryDatePickerToWireCalendar() {
  var wired = false;

  document.addEventListener("DOMContentLoaded", function () {
    if (wired) return;
    wired = true;
    if (typeof wireDeliveryCalendarUI === "function") wireDeliveryCalendarUI();
  });

  var originalOpen = window.wireDeliveryDatePicker;
  if (typeof originalOpen === "function") {
    window.wireDeliveryDatePicker = function () {
      originalOpen();
      if (typeof wireDeliveryCalendarUI === "function") wireDeliveryCalendarUI();
    };
  }
})();